"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _noty = require("noty");

var _node = babelHelpers.interopRequireDefault(require("./node"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _commentForm = babelHelpers.interopRequireDefault(require("./comment-form"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _Discussion = require("../Discussion");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

var CommentBody =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(CommentBody, _Component);

  function CommentBody() {
    babelHelpers.classCallCheck(this, CommentBody);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(CommentBody).apply(this, arguments));
  }

  babelHelpers.createClass(CommentBody, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "comment comment-text",
        style: {
          whiteSpace: 'pre-line'
        }
      }, this.props.children);
    }
  }]);
  return CommentBody;
}(_react.Component);

var CommentNode = (_class = (_temp =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(CommentNode, _Component2);

  function CommentNode() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, CommentNode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(CommentNode)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "node", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "commentPosted", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "trackData", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "discussion", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      expanded: false,
      userProfile: null,
      submitting: false
    };
    return _this;
  }

  babelHelpers.createClass(CommentNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      $(document).on('profileUpdated', this.profileUpdatedEvent);
      (0, _userProfile.getUserProfile)().then(this.profileUpdated);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(document).off('profileUpdated', this.profileUpdatedEvent);
    }
  }, {
    key: "profileUpdatedEvent",
    value: function profileUpdatedEvent(event) {
      this.profileUpdated(event.profile);
    }
  }, {
    key: "profileUpdated",
    value: function profileUpdated(profile) {
      this.setState({
        userProfile: profile
      });
    }
  }, {
    key: "doPostComment",
    value: function doPostComment(comment) {
      return (0, _fetch.default)('data/discussion/post', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          child_type: 'reply',
          parent: this.node.node.id,
          comment: comment,
          trackData: this.trackData
        })
      }).then(function (result) {
        if (result.status == 204) return true;
        if (!result.ok) throw result.json();
        return result.json();
      });
    }
  }, {
    key: "submitComment",
    value: function submitComment(comment) {
      var _this2 = this;

      return new _promisePolyfill.default(function (resolve, reject) {
        _this2.setState({
          submitting: true
        }, function () {
          _this2.doPostComment(comment).then(function (result) {
            _this2.setState({
              submitting: false
            }, function () {
              (0, _noty.showNotificationText)('Your comment has been posted.');

              _this2.commentPosted();

              resolve(true);
            });
          }).catch(function (error) {
            _this2.setState({
              submitting: false
            }, function () {
              reject(error);
            });
          });
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (this.node) {
        return _react.default.createElement("div", {
          className: "comment-thread"
        }, _react.default.createElement(_node.default, {
          discussion: this.discussion,
          node: this.node.node,
          menu: this.node.node.permissions.delete ? [{
            title: 'Delete',
            invoke: this.doDelete
          }] : [],
          oldFooter: _react.default.createElement("footer", null, _react.default.createElement("div", {
            className: "submit"
          }, this.node.node.permissions.reply ? _react.default.createElement("a", {
            className: "btn btn-link",
            onClick: this.doReply,
            href: "javascript:void(0)"
          }, _react.default.createElement("span", {
            className: "material-icons",
            "data-icon": "reply"
          }), "\xA0 Reply") : null, this.node.node.permissions.delete ? _react.default.createElement("a", {
            className: "btn btn-link",
            onClick: this.doDelete,
            href: "javascript:void(0)"
          }, _react.default.createElement("span", {
            className: "material-icons",
            "data-icon": "delete"
          }), "\xA0 Delete") : null))
        }, _react.default.createElement(CommentBody, null, this.node.node.comment)), _react.default.createElement("section", {
          className: _classList.default.join('child-comments', this.state.expanded && 'open')
        }, _react.default.createElement("div", {
          className: "sub-comment-list"
        }, this.node.children.length ? this.node.children.map(function (child) {
          return _react.default.createElement(_Discussion.DiscussionNode, {
            discussion: _this3.discussion,
            trackData: _this3.trackData,
            key: child.node.id,
            commentPosted: _this3.commentPosted,
            node: child
          });
        }) : null), this.node.node.permissions.reply ? _react.default.createElement("div", {
          className: "comment-form"
        }, _react.default.createElement(_commentForm.default, {
          placeholder: "Enter a reply...",
          submitComment: this.submitComment,
          submitting: this.state.submitting,
          userProfile: this.state.userProfile,
          gotCommentField: this.gotCommentField
        })) : null));
      }

      return null;
    }
  }, {
    key: "doDelete",
    value: function doDelete(event) {
      var _this4 = this;

      (0, _fetch.default)('data/discussion/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: this.node.node.id,
          trackData: this.trackData
        })
      }).then(function () {
        (0, _noty.showNotificationText)('The comment has been deleted.');

        _this4.commentPosted();
      });
      if (event) event.preventDefault();
      return false;
    }
  }, {
    key: "gotCommentField",
    value: function gotCommentField(field) {
      this.commentField = field;
    }
  }, {
    key: "toggleExpando",
    value: function toggleExpando() {
      this.setState(function (st) {
        return {
          expanded: !st.expanded
        };
      });
    }
  }, {
    key: "doReply",
    value: function doReply() {
      var _this5 = this;

      this.setState({
        expanded: true
      }, function () {
        _this5.commentField.focus();
      });
    }
  }]);
  return CommentNode;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "profileUpdatedEvent", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "profileUpdatedEvent"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "profileUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "profileUpdated"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "submitComment", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "submitComment"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doDelete", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doDelete"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotCommentField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotCommentField"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "toggleExpando", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "toggleExpando"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doReply", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doReply"), _class.prototype)), _class);
exports.default = CommentNode;